<div *ngIf="soakers?.length == 0">
    <h3>Scan to count!</h3>
</div>
<ul class="soakers">
    <li *ngFor="let soaker of soakers | sortBy:'desc':'numberOfDrinks'">
        <span class="badge">{{soaker.numberOfDrinks}}</span> {{soaker.name}}
    </li>
</ul>
